export default __webpack_public_path__ + "static/media/service-health.e7f2e27b.svg";